export function zip<T, U>(lhs: T[], rhs: U[]): [T, U][] {
  const max = Math.min(lhs.length, rhs.length);
  const out: [T, U][] = [];
  for (let i = 0; i < max; i += 1) {
    out.push([lhs[i], rhs[i]]);
  }
  return out;
}
